
import { Base } from '../base-component';

import './calculator-form.component.scss';
import { TooltipsService } from '../../services/tooltips.service';
import { ValidationService } from '../../services/validation.service';
import { CalculatorService } from '../../services/calculator.service';
import { AnalyticsService } from '../../services/analytics.service';
import * as $ from 'jquery';

export class CalculatorForm extends Base {

	timeout: any = null;

	inputs: Element[];
	modifiers: Element[];
	modifierToggles: Element[];
	modifiersRadiosToggle: Element[];

	addonToggles: Element[];

	validationService: ValidationService;
	calculatorService: CalculatorService;
	expensesModal: Element[];

	calculatorSubmit: Element[];
	calculatorReset: Element[];
	calculator: HTMLFormElement;

	copyFields: Element[];

	modalLinks: Element[];

	formValid: boolean = true;

	termChecker: HTMLFormElement[];

	copyFieldTimeout: any;

	constructor(element: Element,
		analyticsService: AnalyticsService) {
		super(element);
	}

	init() {

		this.inputs = Array.from(this.element.querySelectorAll('input'));
		this.modifiers = Array.from(this.element.querySelectorAll('.js-calculator-modifier'));
		this.modifierToggles = Array.from(this.element.querySelectorAll('.js-calculator-modifier-toggle'));
		this.modifiersRadiosToggle = Array.from(this.element.querySelectorAll('.js-calculator-radio-group'));

		this.addonToggles = Array.from(this.element.querySelectorAll('.js-calculator-addon-toggle'));

		this.calculatorSubmit = Array.from(this.element.querySelectorAll('.js-calculator-calculate'));
		this.calculatorReset = Array.from(this.element.querySelectorAll('.js-calculator-reset'));
		this.calculator = this.element.querySelector('form') as HTMLFormElement;

		this.copyFields = Array.from(this.element.querySelectorAll('.js-copy-field'));

		this.modalLinks = Array.from(this.element.querySelectorAll('.js-calculator-modal'));

		this.termChecker = Array.from(this.element.querySelectorAll("select[name=term]"));

		TooltipsService.initTooltips();

	}

	bindEvents() {

		this.calculatorSubmit.map((item) => item.addEventListener('click', (event) => {
			// animate back to top
			if ($(window).width() > 480) {
				$('html,body').animate({
					scrollTop: $('div.calculators').offset().top - 10
				},
					'slow');
			}
			const allFields: any = this.calculator.querySelectorAll('input');
			if (this.formValid) {
				this.calculatorService.detect(this.calculator);
				// Analytics - Trigger form Complete when the user calculates the results
				this.analyticsService.dtmFormComplete("complete", "");
			}
		}));

		this.modifiersRadiosToggle.map((item) => item.addEventListener('click', (event: any) => {
			let targetField = event.target;
			let visibleGroups = Array.from(this.element.querySelectorAll('div.' + targetField.getAttribute('data-value')));
			let radioContainers = Array.from(this.element.querySelectorAll('.js-calculator-radio-group-containers'));
			radioContainers.map((item) => {
				item.classList.add('calculator-form__hidden');
				let inputs = Array.from(item.querySelectorAll('input'));
				inputs.map((item: any) => {
					let getDefaultValue = item.value;
					if (!getDefaultValue == undefined || getDefaultValue == '') {
						item.value = '';
					} else {
						item.value = getDefaultValue;
					}
				});
			});
			visibleGroups.map((item) => {
				item.classList.remove('calculator-form__hidden');
			});
		}));

		this.calculatorReset.map((item) => item.addEventListener('click', (event) => {
			this.resetInputs(event);
		}));

		this.modifierToggles.map((item) => item.addEventListener('click', (event) => {
			this.toggleModifiers(event);
		}));

		this.addonToggles.map((item) => item.addEventListener('click', (event) => {
			this.toggleAddons(event);
		}));

		this.copyFields.map((item) => item.addEventListener('input', (event) => {
			this.copyField(event);
		}));

		this.copyFields.map((item) => item.addEventListener('change', (event) => {
			this.copyField(event);
		}));

		this.modalLinks.map((item) => item.addEventListener('click', (event) => {
			this.openModal(event);
		}));

		// INPUTS
		this.inputs.map((item) => item.addEventListener('focusin', (event) => {
			this.onFocusInput(event);
		}));

		this.inputs.map((item) => item.addEventListener('focusout', (event) => {
			this.outFocusInput(event);
			this.validationService.validateCalculator(event, this.calculatorSubmit);
			let _valid: Element[] = Array.from(this.element.querySelectorAll('.calculator-form__error'));

			if (_valid.length > 0) {
				this.formValid = false;
				this.calculatorSubmit.map((item) => {
					item.classList.add('button--disabled');
				});
			} else {
				this.formValid = true;
				this.calculatorSubmit.map((item) => {
					item.classList.remove('button--disabled');
				});
			}
		}));

		this.inputs.map((item) => item.addEventListener('keyup', (event) => {
			this.keyInput(event);
		}));

		if (this.termChecker) {
			this.termChecker.map((item) => item.addEventListener('change', (event) => {
				this.checkBaloonPayments(event);
			}));
		}

	}

	openModal(event) {

		let modalId = event.currentTarget.parentNode.getAttribute('data-modal');

		this.event.emit('openModal', {
			id: modalId
		});

	}

	copyField(event) {
		let fieldParentContainer = this.findFieldCopy(event.target.parentNode);
		let copyValue: any = Number.parseFloat(event.target.value);
		let _tmpValue = String(event.target.value).split('.');
		if (_tmpValue.length > 1) {
			if (_tmpValue[1].length > 2) {
				copyValue = Number.parseFloat(event.target.value).toFixed(2);
			}
		}
		let fieldName = fieldParentContainer.getAttribute('data-target');
		let fields = fieldParentContainer.querySelectorAll(`.js-${fieldName}`);
		for (let i = 0; i < fields.length; i++) {
			if (fields[i].classList.contains('js-not-zero')) {
				if (copyValue == 0) {
					copyValue = 1;
				}
			}
			fields[i].value = copyValue;
		}
		// Form form start (if not started yet) when slider is being interacted with
		this.analyticsService.dtmTriggerFormStart(fields[0]);
	}


	findFieldCopy(parent) {
		while ((parent = parent.parentElement) && !parent.classList.contains('js-copy-fields'));
		return parent;
	}

	toggleModifiers(event) {

		event.preventDefault();

		let targetModifierId = event.currentTarget.parentNode.getAttribute('data-target');
		let targetModifier = this.element.querySelector(`#${targetModifierId}`);

		if (targetModifier.classList.contains('calculator-form__modifiers--open')) {
			targetModifier.classList.remove('calculator-form__modifiers--open');
			event.currentTarget.classList.add('calculator-form__link--open');
		} else {
			targetModifier.classList.add('calculator-form__modifiers--open');
			event.currentTarget.classList.remove('calculator-form__link--open');
		}

	}

	toggleAddons(event) {

		event.preventDefault();

		if (event.currentTarget.classList.contains('link--disabled')) {
			return;
		}

		let targetAddonId = event.currentTarget.parentNode.getAttribute('data-target');
		let targetAddon = this.element.querySelector('#' + targetAddonId);

		let targetInput = targetAddon.querySelector("input");

		const _tmpText = event.currentTarget.querySelector(".link__text") as HTMLFormElement;
		const _coAppText = this.element.querySelector(".co_app_text") as HTMLFormElement;

		if (targetAddon.classList.contains("calculator-form__addon--open")) {
			if (targetInput) {
				targetInput.value = "0";
				targetInput.placeholder = "0";
			}
			targetAddon.classList.remove('calculator-form__addon--open');
			_tmpText.innerText = "+ Add co-applicant's income";
			if (_coAppText) {
				_coAppText.innerText = "";
			}
		} else {
			if (targetInput) {
				targetInput.value = "0";
				targetInput.placeholder = "0";
			}
			targetAddon.classList.add('calculator-form__addon--open');
			_tmpText.innerText = "- Remove co-applicant's income";
			if (_coAppText) {
				_coAppText.innerText = "(including co-applicant)";
			}
		}
	}

	resetInputs(event) {
		event.preventDefault();

		let errorLabels = Array.from(this.calculator.querySelectorAll('div.form__group'));
		errorLabels.map((item: any) => {
			let parent: any = item;
			$(parent).removeClass('calculator-form__error');
			$(parent).find('div.calculator-form__error-label').remove();
		});

		this.calculator.reset();
		this.formValid = true;
		this.calculatorService.resetValues(this.calculator);

		this.inputs.map((item: any) => {
			if (item.getAttribute('type') != 'radio') {
				item.setAttribute('data-value', 0);
				item.setAttribute('placeholder', 0);
			}
		});

		// Analytics - Trigger form Complete when the user calculates the results
		this.analyticsService.dtmRestartForm();

	}

	onFocusInput(event) {
		event.preventDefault();
		let field: any = event.target;
		let _value = parseFloat(field.value);
		let min = parseFloat(field.getAttribute('min'));
		let max = parseFloat(field.getAttribute('max'));
		if (min && max) {
			if ((_value < min) && (_value > max)) {
				field.value = "";
			}
		} else {
			if (_value == 0) {
				field.value = "";
			}
		}
	}

	outFocusInput(event) {
		event.preventDefault();
		let field: any = event.target;

		if (!field.classList.contains('js-copy-field')) {
			let value = field.getAttribute('data-value');
			// field.value = value;
			if (field.value == '') {
				field.value = value;
			}
		}

		if (field.value == '') {
			field.value = 0;
		}
	}

	keyInput(event) {
		event.preventDefault();
		this.formValid = true;
		let field: any = event.target;
		let value = field.value;

		if (!field.classList.contains('js-copy-field')) {
			field.setAttribute('data-value', value);
			field.setAttribute('placeholder', value);
		}

		this.formValid = this.validationService.validateCalculator(event, this.calculatorSubmit);
	}

	checkBaloonPayments(event) {
		let value = event.currentTarget.value;

		let balloonInput: HTMLFormElement[] = Array.from(this.element.querySelectorAll(".js-balloon"));

		if (balloonInput.length > 0) {
			if (value == '84') {
				balloonInput.forEach(element => {
					element.value = "0";
					element.placeholder = "0";
					element.max = "0";
					element.min = "0";
					element.setAttribute("data-value", "0");
				});
			} else {
				balloonInput.forEach(element => {
					element.value = "1";
					element.placeholder = "1";
					element.max = "40";
					element.min = "1";
					element.setAttribute("data-value", "1");
				});
			}
		}
	}
}



// WEBPACK FOOTER //
// ./components/calculator-form/calculator-form.component.ts